module.exports = __webpack_public_path__ + "static/media/Income.5c569d01.svg";